export default __webpack_public_path__ + "static/media/gana2.16970c88.png";